import Link from 'next/link'
import { format } from 'date-fns'
import ContentContainer from './ContentContainer'

interface PodcastsListProps {
	heading?: string
	addArchiveLink?: any
	podcasts: Array<any>
}

const PodcastsList = (props: PodcastsListProps) => {

	const { heading, addArchiveLink, podcasts } = props

	if ( !podcasts || podcasts.length === 0 ) {
		return null
	}

	return (
		<ContentContainer
			heading={heading}
			modifierClass=""
			link={addArchiveLink ? <Link href="/podcasts" className='button button--inverted'>View all podcasts →</Link> : null}
		>

			<div className="podcasts-list">
				<div className="podcasts-list__wrapper">
					{podcasts.map((podcast: any) => {
						

						// If spotify_url or apple_url indlues two https:// (example: https://urldefense.com/v3/__https://podcasts.apple.com/no/podcast/arcticpodden/id1547993092__;!!G2LzpLiaFdozy4f_Gg!zlgBwiB86idHYytQu2AaK7Dq01v5utPH1aQ_jobrB26jYsWi-sOiDP_j_6t_pEVmB_YVBDr6Z84$), remove everything before the first one. The first one is some url defence.
						if (podcast.spotify_url && podcast.spotify_url.indexOf('https://') !== podcast.spotify_url.lastIndexOf('https://')) {
							podcast.spotify_url = podcast.spotify_url.substring(podcast.spotify_url.indexOf('https://'), podcast.spotify_url.length);
						}
						if (podcast.apple_url && podcast.apple_url.indexOf('https://') !== podcast.apple_url.lastIndexOf('https://')) {
							podcast.apple_url = podcast.apple_url.substring(podcast.apple_url.indexOf('https://'), podcast.apple_url.length);
						}
						/* Podcast from API */
						if (podcast.spotify_url) {
							const spotifyID = podcast.spotify_url.replace('https://open.spotify.com/episode/', '');
							const embedCode =
								`<iframe style="border: none" src="https://open.spotify.com/embed/episode/${spotifyID}" width="100%" height="552" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"></iframe>`;
							return (
								<div key={podcast.id} className="podcasts-list__row">
									<div className="podcasts-list__episode">
										<div className="podcasts-list__thumbnail">
											<div className="podcasts-list__content-media" dangerouslySetInnerHTML={{ __html: embedCode }} />
										</div>
										<div className="podcasts-list__content">
											<div className="podcasts-list__content-header">
												<p className="podcasts-list__publish-date">{`${format(new Date(podcast.published_at), 'MMMM do yyyy')}`}</p>
												<h3>{podcast.title}</h3>
												<p>{podcast.description}</p>
												<ul className="podcasts-list__link-list">
													{podcast.spotify_url && <li><Link href={podcast.spotify_url} target="_blank" rel="noopener noreferrer" className='button button--inverted'>Listen in Spotify →</Link></li>}
													{podcast.apple_url && <li><Link href={podcast.apple_url} target="_blank" rel="noopener noreferrer" className='button button--inverted'>Listen in Apple Music →</Link></li>}
												</ul>
											</div>
										</div>
									</div>
								</div>
							)
						} else {
							const asset = podcast.podcast[0] ? podcast.podcast[0] : null;
							if (asset?.embeddedAsset?.providerName == "Spotify") {
								return (
									<div key={podcast.id} className="podcasts-list__row">
										<div className="podcasts-list__episode">
											<div className="podcasts-list__thumbnail">
												<div className="podcasts-list__content-media" dangerouslySetInnerHTML={{ __html: asset ? asset.embeddedAsset.html : '' }} />
											</div>
											<div className="podcasts-list__content">
												<div className="podcasts-list__content-header">
													<p className="podcasts-list__publish-date">{`${format(new Date(asset.embeddedAsset.publishedTime), 'MMMM do yyyy')}`}</p>
													<h3>{asset.embeddedAsset.title}</h3>
													<p>{podcast.description ? podcast.description : asset.embeddedAsset.description}</p>
													<ul className="podcasts-list__link-list">
														{asset.embeddedAsset.url && <li><Link href={asset.embeddedAsset.url} target="_blank" rel="noopener noreferrer" className='button button--inverted'>Listen in Spotify →</Link></li>}
													</ul>
												</div>
											</div>
										</div>
									</div>
								)
							} else {
								return (
									<div key={podcast.id} className="podcasts-list__row--compact">
										<div className="podcasts-list__content-header">
											<h3>{podcast.title}</h3>
											<p>{podcast.description}</p>
										</div>
										<div className="podcasts-list__content-media" dangerouslySetInnerHTML={{ __html: asset ? asset?.embeddedAsset?.html : '' }} />
									</div>
								)
							}
						}
					})}
				</div>
			</div>
		</ContentContainer>
	)

}
export default PodcastsList
